export const URL_ENDPOINTS = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    FINANCIAL: process.env.REACT_APP_URL_API_LOAN,
    SECURITY: process.env.REACT_APP_URL_API_SECURITY + "/token",
    ACCOUNT: process.env.REACT_APP_URL_API_ACCOUNT
}

export enum ROUTES_PATH {
    ENTRY = "/",
    ENTRY_CO = '/entry-co',
    TYPES_PAYMENTS = "/types-payments",
    TPV = '/tpv',
    VERIFY_CARD_TPV = '/verify-card-tpv',
    TRANSITION = "/transition",
    TIMEOUT = "/timeout",
    DENIAL = "/denial",
    UNKNOWN_ERROR = "/unknown-error",
    UNPROCESSABLE = "/unprocessable",
    SUCCESS = '/success',
    PAYMENT_CHECK = '/payment-check',
    NO_DEBT = '/no-debt',
    LEGAL_NOTICE = '/legal-notice',
    PRIVACY_POLICY = '/privacy-policy',
    COOKIES_POLICY = '/cookies-policy',
    PAYMENT_ON_COURSE = '/payment-on-course',
    CARD_UP_TO_DATE = '/card-up-to-date',
    CO_CLIENT_ERROR = '/co-client-error',
}

export const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;